import Icon from '../components/Icon';

const TrailPaved = Icon(
  'trail-paved',
  <>
    <path d="M24 4.25H0v1.5h24zM24 18.25H0v1.5h24zM18.75 12.75h4.5c.398 0 .75-.352.75-.75a.77.77 0 0 0-.75-.75h-4.5A.77.77 0 0 0 18 12c0 .398.352.75.75.75M14.77 12.75H9.25A.77.77 0 0 1 8.5 12c0-.398.352-.75.75-.75h5.52c.398 0 .75.352.75.75s-.352.75-.75.75M.75 12.75h4.5c.398 0 .75-.352.75-.75a.77.77 0 0 0-.75-.75H.75A.77.77 0 0 0 0 12c0 .398.352.75.75.75" />
  </>
);

export default TrailPaved;
